import React from 'react';

import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Typography } from '@mui/material';

import RelatedListCard from '../RelatedListCard';
import RelatedTile from '../RelatedTile';
import RelatedTileGrid from '../RelatedTileGrid';
import { accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';
import { useAccountRelatedPreview } from '../useAccountRelatedRows';

import { toAccountCase } from './toAccountCase';

interface Props {
  accountId: string;
}

export default function AccountCasesCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { count, error, isLoading, rows: cases } = useAccountRelatedPreview(accountId, 'cases', toAccountCase);

  return (
    <RelatedListCard
      count={count}
      error={error}
      icon={<SupportAgentIcon color="action" />}
      isLoading={isLoading}
      title="Cases"
      viewAllTo={accountPath(accountId, offerId, '/cases')}
    >
      <RelatedTileGrid>
        {cases.map((accountCase) => (
          <RelatedTile
            key={accountCase.id}
            fields={[
              { label: 'Contact Name', value: accountCase.contactName },
              { label: 'Subject', value: accountCase.subject },
              { label: 'Priority', value: accountCase.priority },
            ]}
            heading={
              <Typography variant="subtitle1" component="h3">
                {accountCase.caseNumber}
              </Typography>
            }
          />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
